/**
 * Application version information
 * This is automatically synced from package.json
 */
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;
export const APP_NAME = packageJson.name;
// The sales portal is versioned separately from the admin and compliance portals.
export const SALES_PORTAL_VERSION = packageJson.salesPortalVersion;

/**
 * Get formatted version string
 * @returns Version string in format "v1.2.3"
 */
export function getVersionString(): string {
  return `v${APP_VERSION}`;
}

/**
 * Get the sales portal's formatted version string
 * @returns Version string in format "v1.2.3"
 */
export function getSalesPortalVersionString(): string {
  return `v${SALES_PORTAL_VERSION}`;
}

/**
 * Get full version info
 */
export function getVersionInfo() {
  return {
    version: APP_VERSION,
    name: APP_NAME,
    formattedVersion: getVersionString(),
  };
}
